import {appendFormData, getFrontendBase, showErrorMessage} from '@/helper';
import {clearImpersonation} from '@/services/AuthService';

export default {
    fetchRecords(body) {
        return new Promise((resolve, reject) => {
            http.post('api/users/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveUser(user) {
        return new Promise((resolve, reject) => {
            http.post('api/users' + (user.id ? '/' + user.id : ''), user).then(response => {
                resolve(response.data);
            }).catch(error => {
                if (error.response.data.message) {
                    showErrorMessage(error.response.data.message);
                } else {
                    reject([]);
                }
            });
        });
    },

    deleteUser(id) {
        return new Promise((resolve, reject) => {
            http.delete('api/users/' + id).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
    },

    getUsers() {
        return new Promise((resolve, reject) => {
            http.get('api/users').then(response => {
                resolve(response.data.users);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getUser(id) {
        return new Promise((resolve, reject) => {
            http.get('api/users/' + id).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
    },

    deimpersonate() {
        return new Promise((resolve, reject) => {
            http.get('api/auth/deimpersonate').then(response => {
                // Neukládáme response.data.token do localStorage - identita, kterou
                // panel měl před impersonací, tam zůstala celou dobu nedotčená.
                // Stačí smazat impersonační overlay tohoto panelu a panel se k ní
                // sám vrátí; zápis do sdíleného localStorage by mohl přepsat
                // novější přihlášení v jiném panelu.
                clearImpersonation();
                window.location.href = getFrontendBase();
                setTimeout(function () {
                    window.location.reload();
                }, 500);
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
    },

    sendSignNotification(user_ids) {
        return new Promise((resolve, reject) => {
            http.post('api/users/send-sign-notification', {user_ids}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
    },

    processInteractionFormsStep(step, interactionFormsID) {
        const formData = new FormData();

        appendFormData(formData, {
            ...step
        });

        return new Promise((resolve, reject) => {
            http.post(`api/interaction-forms/${interactionFormsID}/process-step`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
    },

    getInteractionForms() {
        return new Promise((resolve, reject) => {
            http.get('api/interaction-forms').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    checkUniqueEmail(email) {
        return new Promise((resolve, reject) => {
            http.get('api/check-unique-email?email=' + email).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error.response.data);
            });
        });
    },

    saveUserAsClient(form) {
        return new Promise((resolve, reject) => {
            http.post('api/users/save-as-client', form).then(response => {
                resolve(response.data);
            }).catch(error => {
                // Chybu vždy předat volajícímu (SelfRegister.vue), který ji zobrazí ve formuláři.
                reject({status: error.response?.status ?? null, ...(error.response?.data ?? {})});
            });
        });
    },
}
